import { useState } from "react";

import { showGrade } from "../../../../../utils/textUtils";

const LevelTab = ({
  groupedStudents,
  handleClickAllStudents,
  handleClickStudent,
  selectedParams,
}) => {
  const [expandedLevels, setExpandedLevels] = useState({});

  const handleToggle = (levelId) => {
    setExpandedLevels((prev) => ({
      ...prev,
      [levelId]: !prev[levelId],
    }));
  };

  const styles = {
    classDetail: {
      color: "#737373",
    },
    classHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      border: "none",
      fontSize: "18px",
    },
    studentList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",
      maxHeight: "0",
      transition: "max-height 0.3s ease, opacity 0.3s ease",
      opacity: 0,
      fontSize: "16px",
    },
    studentListVisible: {
      maxHeight: "none",
      opacity: 1,
    },
    studentItem: {
      display: "flex",
      padding: "8px 10px",
      backgroundColor: "#fff",
      color: "#737373",
      border: "none",
      marginTop: "5px",
    },
  };

  return Object.entries(groupedStudents).map(
    ([levelId, { name, students }]) => (
      <li key={levelId}>
        <div
          style={{
            backgroundColor: expandedLevels[levelId] ? "#EBEBEB" : "#fff",
            color: expandedLevels[levelId] ? "#000" : "#737373",
            ...styles.classHeader,
          }}
          onClick={() => handleToggle(levelId)}
        >
          <span>{name}</span>
          <span style={styles.classDetail}>{students.length}명</span>
        </div>
        <ul
          style={{
            ...styles.studentList,
            ...(expandedLevels[levelId] ? styles.studentListVisible : {}),
          }}
        >
          <li
            key={"group_" + levelId}
            style={{
              ...styles.studentItem,
              color: selectedParams.levelId === levelId ? "#000" : "#737373",
              fontWeight: "bold",
            }}
            onClick={() => handleClickAllStudents(levelId)}
          >
            전체 학생
          </li>
        </ul>
        <ul
          style={{
            ...styles.studentList,
            ...(expandedLevels[levelId] ? styles.studentListVisible : {}),
          }}
        >
          {students.map((student) => (
            <li
              key={student.id}
              style={{
                ...styles.studentItem,
                color:
                  selectedParams.studentId === student.id ? "#000" : "#737373",
              }}
              onClick={() => handleClickStudent(student.id)}
            >
              {student.name} ({showGrade(student.grade)})
            </li>
          ))}
        </ul>
      </li>
    )
  );
};

export default LevelTab;
